import React, { useState, useRef, useCallback } from "react";
import {
  GoogleMap,
  LoadScript,
  Autocomplete,
  Marker,
} from "@react-google-maps/api";
import { GOOGLE_MAP_KEY } from "../redux/api/Constants";

const libraries = ["places"];

const containerStyle = {
  width: "100%",
  height: "600px",
};

const center = {
  lat: 37.7749,
  lng: -122.4194,
};

const GMap = () => {
  const [mapCenter, setMapCenter] = useState(center);
  const mapRef = useRef(null);
  const autoCompleteRef = useRef(null);

  const onLoad = useCallback((map) => {
    mapRef.current = map;
  }, []);

  const onCenterChanged = () => {
    if (mapRef.current) {
      const newCenter = {
        lat: mapRef.current.getCenter().lat(),
        lng: mapRef.current.getCenter().lng(),
      };
      setMapCenter(newCenter);
      console.log("New center:", newCenter);
    }
  };

  const onAutoCompleteLoad = (autocomplete) => {
    autoCompleteRef.current = autocomplete;
  };

  const onPlaceChanged = () => {
    if (autoCompleteRef.current !== null) {
      const place = autoCompleteRef.current.getPlace();
      if (place.geometry) {
        const newPos = {
          lat: place.geometry.location.lat(),
          lng: place.geometry.location.lng(),
        };
        setMapCenter(newPos);
        mapRef.current.panTo(newPos);
      }
    }
  };

  const mapOptions = {
    fullscreenControl: false, // Hide fullscreen button
    mapTypeControl: false, // Hide map/satellite toggle
    streetViewControl: false, // Hide street view pegman
    zoomControl: false, // Hide zoom in/out buttons
    rotateControl: false, // Hide compass/rotate
    scaleControl: false, // Hide scale bottom left
    clickableIcons: false, // Disable default place icons
    disableDefaultUI: false, // Keep default UI if needed, or true to hide all
  };

  return (
    <LoadScript googleMapsApiKey={GOOGLE_MAP_KEY} libraries={libraries}>
      <div className="p-4">
        <Autocomplete
          onLoad={onAutoCompleteLoad}
          onPlaceChanged={onPlaceChanged}
        >
          <input
            type="text"
            placeholder="Search a place"
            style={{
              width: "40%",
              padding: "12px 16px",
              borderRadius: "12px",
              border: "1px solid #ccc",
              boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
              fontSize: "16px",
              outline: "none",
              zIndex: 1,
            }}
          />
        </Autocomplete>

        <GoogleMap
          mapContainerStyle={containerStyle}
          center={mapCenter}
          zoom={14}
          options={mapOptions}
          onLoad={onLoad}
          onIdle={onCenterChanged}
        >
          <Marker position={mapCenter} />
        </GoogleMap>
      </div>
    </LoadScript>
  );
};

export default GMap;
